export const rusheeInfo = [
  {
    label: 'Name',
    value: 'name'
  },
  {
    label: 'Phone',
    value: 'phone'
  },
  {
    label: 'Email',
    value: 'email'
  },
  {
    label: 'Year',
    value: 'year'
  },
  {
    label: 'Graduation Year',
    value: 'graduationYear'
  },
  {
    label: 'Major',
    value: 'major'
  },
  {
    label: 'What brought you out?',
    value: 'reasons'
  },
  {
    label: 'Other Reasons',
    value: 'otherReasons'
  },
  {
    label: 'Why do you want to join?',
    value: 'why'
  },
  {
    label: 'What traits and qualities do you possess that would make you a good brother?',
    value: 'traits'
  },
];

export const interviewResponses = [
  {
    label: '1. General - In a couple of sentences, tell us about yourself.',
    value: 'question1'
  },
  {
    label: '2. Technical - What are the three pillars of Theta Tau? Which pillar do you look forward to the most?',
    value: 'question2'
  },
  {
    label: '3. Logistics - What are you looking for in Theta Tau?',
    value: 'question3'
  },
  {
    label: '4. Logistics - What was your most memorable moment during rush week?',
    value: 'question4'
  },
  {
    label: '4a. Which active do you feel like you bonded with the most?',
    value: 'question4a'
  },
  {
    label: '5. Professional - Why did you choose to pursue your degree? What do you hope to accomplish with your major',
    value: 'question5'
  },
  {
    label: '6. Group - Describe a situation where you had a conflict with another individual or a group of people, and how you handled it.',
    value: 'question6'
  },
  {
    label: '7. Character - What life philosophy do you live by? Why?',
    value: 'question7'
  },
  {
    label: '8. Character - Can you describe a turning point that has shaped who you are today?',
    value: 'question8'
  },
  {
    label: '9. Character - Think of a time that you or a friend or loved one was going through a hard time, how did you overcome it or help them get through it?',
    value: 'question9'
  },
  {
    label: '10. Character - What areas do you think you need to improve upon in your life, and what have you done to make changes?',
    value: 'question10'
  },
  {
    label: '11. Character - Describe what home means to you.',
    value: 'question11'
  },
  {
    label: '11a. How do you feel about your time here at UCSD so far?',
    value: 'question11a'
  },
  {
    label: '12. Logistics - What is your typical week look like and how do you organize it?',
    value: 'question12'
  },
  {
    label: '13. Logistics - Are you involved in any other extracurriculars?',
    value: 'question13'
  },
  {
    label: '13a. If YES, ask: How much of a time commitment is this? How would you be able to prioritize Theta Tau?',
    value: 'question13a'
  },
];



// WEBPACK FOOTER //
// ./src/containers/DelibsApp/RusheeProfile/data.js